const AI_PRODUCTS = [
  {
    slug: 'ai-powered-erp',
    gif: '/img/erp_dashboard.gif',
    name: 'AI-Powered ERP',
    desc: 'An AI-Powered ERP that transforms manufacturing from spreadsheet chaos to autonomous operations. It uses predictive ML to forecast demand, auto-generate orders, detect shrinkage instantly, and route approvals intelligently—turning coordinators into data-driven decision makers.',
    externalUrl: 'https://precision.monkstack.com/',
    externalLabel: 'Visit Monkstack ERP',
  },
  {
    slug: 'ai-shopping-assistant',
    gif: '/img/ai-shopping.gif',
    name: 'AI Shopping Assistant',
    desc: 'An AI shopping assistant that understands what customers really want, not just what they type. It uses semantic search and personalized recommendations to match intent with products in real-time, making shopping conversational and friction-free.',
  },
  {
    slug: 'ai-3d-renderer',
    gif: '/img/ai-3d-renderer.gif',
    name: 'AI 3D Renderer',
    desc: 'An AI system that instantly transforms flat floor plans into interactive 3D models. It uses visual machine learning to understand architectural drawings and generates navigable 3D spaces that entire teams can explore, annotate, and share—no CAD skills required.',
  },
  {
    slug: 'ai-cms',
    gif: '/img/img-enhancer.gif',
    name: 'AI CMS',
    desc: 'AI CMS - a product data and image-enrichment platform for cannabis retailers. It continuously syncs catalogues from any POS into one clean schema, uses natural-language understanding to read messy vendor data and recommend the right product imagery, and gives merchandising teams a fast, auditable workspace to review and approve every image decision.',
  },
];

export const getProductBySlug = (slug) =>
  AI_PRODUCTS.find((product) => product.slug === slug);

export default AI_PRODUCTS;
